module.exports = __webpack_public_path__ + "static/media/Anton.10c68188.ttf";